import { render } from "./ContactPersonInfoShow.vue?vue&type=template&id=151d98f8"
import script from "./ContactPersonInfoShow.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactPersonInfoShow.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/start/ContactPersonInfoShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "151d98f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('151d98f8', __exports__)) {
    api.reload('151d98f8', __exports__)
  }
  
  module.hot.accept("./ContactPersonInfoShow.vue?vue&type=template&id=151d98f8", () => {
    api.rerender('151d98f8', render)
  })

}


export default __exports__